import { Container, Row, Col } from 'react-bootstrap';
import  MouseEvent from "react";
import { useState }  from "react";
import { Link45deg } from "react-bootstrap-icons";

interface ListItemProps{
    id: string;
    text: string;
    url: string;
}

interface ListWithHeaderProps {
    title: string;
    title_url?: string;
    items: ListItemProps[];
    /*onSelectItem: (item: string) => void;*/
}

function ListWithHeader({items, title_url = "", title}: ListWithHeaderProps){



    return (
        <> 
            <Container>
                { title_url && 
                    <Row>
                        <Col className="text-start"><a href={title_url} className="text-start text-font-size-medium text-font-body text-font-heavy"><Link45deg /> {title}</a></Col>
                    </Row>
                }
                { !title_url && 
                    <Row>
                        <Col className="text-start"><p className="my-0 text-start text-font-body text-font-heavy">{title}</p></Col>
                    </Row>
                }
                {items.map( (item) => 
                    <Row>
                        <Col className="text-start">
                            <a href={item.url} className="text-font-body text-font-light"><Link45deg /> {item.text}</a>
                        </Col>
                    </Row>
                )}
                <Row>

                </Row>
            </Container>
            
        </>
    );

}

export default ListWithHeader;